var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3H10V11H5.00003L12 18L19 11H14V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 3C9.00003 2.44772 9.44774 2 10 2H14C14.5523 2 15 2.44772 15 3V10H19C19.4045 10 19.7691 10.2436 19.9239 10.6173C20.0787 10.991 19.9931 11.4211 19.7071 11.7071L12.7071 18.7071C12.3166 19.0976 11.6834 19.0976 11.2929 18.7071L4.29292 11.7071C4.00692 11.4211 3.92137 10.991 4.07615 10.6173C4.23093 10.2436 4.59557 10 5.00003 10H9.00003V3ZM14 11V3H10V11H5.00003L12 18L19 11H14Z",
    fill: "#797979"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.00003,
    y: 20,
    width: 16,
    height: 2,
    fill: "#E57200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.731cadc95b0467e8a28e56dc5e6e12cc.svg";
export { ForwardRef as ReactComponent };